<template>
  <accordion ref="accordionFiltroLote">
    <template #header="{ expandido }">
      <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center">
        <h4 class="font-size-16 mb-0" style="font-weight: 600;">
          FILTRO DE LOTES
        </h4>
      </div>

      <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end align-items-center order-1 order-md-2 mb-2 mb-md-0">
        <i
          :class="expandido ? 'mdi mdi-filter' : 'mdi mdi-filter-outline'"
          class="icone-accordion"
        ></i>
      </div>
    </template>

    <div class="row d-flex mb-1">
      <div class="col-md-3">
        <inputCooperado @cooperadoSelecionado="setCooperado"/>
      </div>
      
      <div class="col-md-3">
        <b-form-group label="Lote">
          <multiselect v-model="selecaoLote" :loading="loadingLotes" :options="selecaoLoteLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="150"/>
        </b-form-group>
      </div>

      <div class="col-md-3">
        <b-form-group label="Data do Importação" invalid-feedback="Campo obrigatório">
          <date-picker
            v-model="dataImportacao"
            value-type="YYYY-MM-DD HH:mm:ss"
            format="DD/MM/YYYY"
          />
          </b-form-group>
      </div>

      <div class="col-md-3">
        <b-form-group label="Status">
          <multiselect v-model="selecaoStatus" :options="selecaoStatusLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="200"/>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1">
        <b-button variant="secondary" class="me-md-3 mb-2 mb-md-0" @click="limpar">
          <i class="mdi mdi-broom"></i> Limpar
        </b-button>
        <b-button variant="primary" @click="emitirFiltro" :disabled="disabledFiltro">
          <i class="mdi mdi-filter-outline"></i> Filtrar
          <b-spinner
            variant="secondary"
            small
            class="ms-2"
            v-if="disabledFiltro"
          ></b-spinner>
        </b-button>
      </div>
    </div>
  </accordion>
</template>

<script>
import Multiselect       from "vue-multiselect";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import accordion         from "@/components/accordion";
import inputCooperado    from "@/components/astec/projetos/lotesImportacao/inputCooperado";

export default {
  mixins    : [clienteRuralMixin],
  components: { Multiselect, accordion, inputCooperado },
  props: {
    atualizarLkpLote: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingLotes    : true,
      disabledFiltro  : false,
      filtroCarregou  : false,
      selecaoLote     : null,
      selecaoStatus   : null,
      dataImportacao  : null,
      selecaoLoteLkp  : [],
      selecaoStatusLkp: [{name: "Pendente", value: "PENDENTE"}, {name: "Parcial", value: "PARCIAL"}, {name: "Concluído", value: "CONCLUÍDO"}],
      cdPessoa        : null,
    };
  },
  methods: {
    async buscarLkpLote(cdPessoa) {

      await this.$http.get(`/api/astec/projetos/importarProjetos/getLkpLote/${cdPessoa}`)
      .then((response) => {
        
        this.selecaoLoteLkp = response.data.lotes;

      })
      .catch((error) =>{
      
        this.$tools.alerta(error.response.data.message, "error");
      
      })
      .finally(() =>{
        
        this.loadingLotes = false;
        
      });

    },
    limpar() {
      this.selecaoLote    = null;
      this.selecaoStatus  = null;
      this.dataImportacao = null;

      this.$emit('limparGrid');
    },
    emitirFiltro(){
      const filtro = {
        sq_astec_integracao_lote: this.selecaoLote?.value   ?? null,
        dt_importacao           : this.dataImportacao       ?? null,
        status                  : this.selecaoStatus?.value ?? null,
        cd_pessoa               : this.cdPessoa             ?? null
      }

      this.$emit('filtroLote', filtro);

      if(!this.filtroCarregou) {
        this.filtroCarregou = true;
      }else{
        this.$refs.accordionFiltroLote.fechar();
      }
    },
    setCooperado(cooperado) {
      this.cdPessoa    = cooperado.value;
      this.selecaoLote = null;

      this.buscarLkpLote(this.cdPessoa);

      if(!this.filtroCarregou) {
        this.emitirFiltro();
      }
    }
  },
  watch: {
    atualizarLkpLote(newValue) {
      if (newValue) {
        this.buscarLkpLote(this.cdPessoa);
      }
    }
  }
};

</script>